import { Injectable } from "@angular/core";
import { HomesFacade } from "@library/store/homes/homes.facade";

@Injectable()
export class SetPointService {
  setPoint: number;
  endTime: number;

  constructor(
    private homesFacade: HomesFacade,
  ) {

  }

  changeSetPoint(homeId: string, roomId: string, mode: string) {
    return this.homesFacade.setThermPoint(
      homeId,
      roomId,
      mode,
      this.endTime,
      this.setPoint
    );
  }
}